import { NgModule } from '@angular/core';

import * as Header from '@reg/header';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@NgModule({
    // Compiled ahead of time for initial load
    entryComponents: [
        Header.HeaderComponent,
    ],
    declarations: [
        Header.HeaderComponent,
        Header.EventHeaderComponent,
    ],
    exports: [
        Header.HeaderComponent,
        Header.EventHeaderComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
    ],
})
export class HeaderModule {
}
